import React, { useContext, useEffect, useRef, useState } from 'react';
import DataGrid, { Column, Editing, Paging, Lookup } from 'devextreme-react/data-grid';
import ButtonDefault from '../../components/ButtonDefault/ButtonDefault';
import { API } from '../../API/API';
import { UserContext } from '../../context/UserContext';
import LoadSpin from '../../components/LoadSpin/LoadSpin';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

const ManyEmpEmplHist = (props) => {

    const navigate = useNavigate();
    const gridRef = useRef();
    const { userInfo } = useContext(UserContext);

    const [data, setData] = useState([]);
    const [dDepartment, setDDepartment] = useState([]);
    const [dPosition, setDPosition] = useState([]);
    const [dInsureType, setDInsureType] = useState([]);

    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const getData = async () => {
        let tData = [];
        let tDDepartment = [];
        let tDPosition = [];
        let tDInsureType = [];

        try {
            setLoading(true);
            await API.get('/api/humanresource/organization/get_department_dropdown?companyid=' + userInfo.companyid).then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tDDepartment = response?.data?.retdata;
                }
            });
            await API.get('/api/humanresource/organization/get_position_dropdown?companyid=' + userInfo.companyid).then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tDPosition = response?.data?.retdata;
                }
            });
            await API.get('/api/humanresource/organization/get_insure_type_dropdown').then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tDInsureType = response?.data?.retdata;
                }
            });
            await API.get('/api/humanresource/organization/getECEmployment').then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tData = response?.data?.retdata;
                }
            });
        } finally {
            setLoading(false);
        }

        tDPosition?.map(r => r.key = parseInt(r?.key));
        tDInsureType?.map(r => r.key = parseInt(r?.key));

        setDInsureType(tDInsureType);
        setDDepartment(tDDepartment);
        setDPosition(tDPosition);
        setData(tData);
    }

    useEffect(() => {
        getData();
    }, [])

    const onSave = async () => {

        let vSuccess = false;
        let tData = [...data];
        let tGrid = gridRef?.current?.instance?.getController('editing')?._changes;
        if (tGrid?.length > 0) {
            tGrid?.map(r => {
                if (r?.type == "update" && r.data) {
                    let tIndex = tData?.map(ri => ri.historyid).indexOf(r.key);
                    if (tIndex >= 0) {
                        tData[tIndex] = {
                            ...tData[tIndex],
                            ...r.data
                        };
                    }
                }
            });
        }

        if (tData?.length > 0) {

            let unFinished = tData?.filter(r => {
                if (r?.basewage > 0 && r?.begindate && r?.depid && r?.insuretypeid && r.positionid) {
                    return false;
                } else {
                    return true;
                }
            });

            if (unFinished?.length == 0) {
                try {
                    setLoadingSave(true);
                    await API.post("/api/humanresource/employment/SaveECEmployment", tData).then(response => {
                        if (response?.status == 200 && response?.data?.rettype == 0) {
                            message.success("Амжилттай");
                            vSuccess = true;
                        }
                    });
                } finally {
                    setLoadingSave(false);
                }
            } else {
                message.warning("Мэдээлэл дутуу байна!");
            }
        }

        setData(tData);
        if (vSuccess) {
            navigate("/hrsuite/home");
        }
    }

    const onChangeDep = (newData, value, currentRowData) => {
        newData.depid = value;
        newData.positionid = null;
    }

    if (loading) {
        return (
            <LoadSpin space />
        );
    }

    return (
        <div className='hideGridHeader' style={{ padding: 16 }}>
            <div style={{ marginBottom: 16, width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontWeight: 700, fontSize: 16 }}>Одоогийн ажил эрхлэлт оруулах</div>
                {loadingSave ? <LoadSpin /> : <ButtonDefault disabled={data?.length == 0} onClick={onSave} text="Хадгалах" />}
            </div>
            <DataGrid
                ref={gridRef}
                dataSource={data}
                keyExpr="historyid"
                showBorders={true}
                onEditorPreparing={(e) => {
                    if (e.parentType == 'dataRow' && e.dataField == 'positionid') {
                        e.editorOptions.dataSource = dPosition?.filter(r => r.depid == e?.row?.data?.depid)
                    }
                }}
            >
                <Paging enabled={false} />
                <Editing
                    mode="batch"
                    allowUpdating={true}
                    startEditAction="click" />
                <Column allowEditing={false} dataField="fullname" caption="Ажилтан" disable={true} />
                <Column caption="Одоогийн ажил эрхлэлт">
                    <Column dataField="depid" caption="Байгууллага нэгж" setCellValue={onChangeDep} >
                        <Lookup dataSource={dDepartment} valueExpr="key" displayExpr="text" />
                    </Column>
                    <Column dataField="positionid" caption="Ажлын байр" >
                        <Lookup dataSource={dPosition} valueExpr="key" displayExpr="text" />
                    </Column>
                    <Column dataField="insuretypeid" caption="Даатгуулагчийн төрөл" >
                        <Lookup dataSource={dInsureType} valueExpr="key" displayExpr="text" />
                    </Column>
                    <Column dataField="begindate" caption="Эхэлсэн огноо" dataType="date" />
                    <Column dataField="basewage" caption="Үндсэн цалин" dataType="number" format="fixedPoint" />
                </Column>
            </DataGrid>
        </div >
    );
}

export default ManyEmpEmplHist;